module.exports = __webpack_public_path__ + "static/media/sensor1.0e02ebb7.jpg";